const TEXT_CHARACTERS = {
  VERTICAL: 3500,
  STACKED: 3500,
  OVERTIME: 2000,
  KEY_FINDINGS: 3000,
};

export default TEXT_CHARACTERS;
